import AssetFieldIcon from "../components/asset/AssetFieldIcon";

export const urlRoutes = {
  splash: "/",
  signup: "/sign-up",
  dashboard: "/dashboard",
  home: "/home",
  login: "/login",
  register: "/company-registration",
  incidentsDashboard: "/incidents-dashboard",
  forms: "/forms",
  auditReports: "/audit-reports",
  itTicketing: "/it-ticketing",
  formBuilder: "/form-builder",
  accounts: "/accounts",
  paymentProcessing: "/payment-processing",
  incidentReports: "/incident-reports",
  maintenanceRequests: "/maintenance-requests",
  surveys: "/surveys",
  glAccounts: "/gl-accounts",
  otherReports: "/other-reports",
  reportScheduling: "/report-scheduling",
  formConfiguration: "/form-builder",
  incidentsReportsEditing: "/incidents-reports-editing",
  incidentsReportsPreview: "/incidents-form-preview",
  reportView: "/report-view",
  reportViewDeprecated: "/submitted-report-view",
  form: "/form",
  locationsDashboard: "/locations-dashboard",
  companyLocations: "/company-locations",
  usersDashboard: "/users-dashboard",
  companyUsers: "/company-users",
  setPassword: "/set-password",
  photoGallery: "/photo-gallery",
  receiptTracker: "/receipt-tracker",
  inventoryManagement: "/inventory-management",
  assetManagement: "/asset-management",
  companyProfile: "/company-profile",
  companyPositions: "/company-positions",
  forgotPassword: "/forgot-password",
  termsOfService: "/terms-of-service",
  privacy: "/privacy-policy",
  assets: "/assets",
  preventativeMaintenance: "/preventative-maintenance",
  disposedAssets: "/disposed-assets",
  assetParts: "/asset-parts",
  vendorContacts: "/vendors-contacts",
  vendors: "/vendors",
  notifications: "/my-notifications",
  tasks: "/my-tasks",
};

export const drawerWidthSmall = 220;
export const drawerWidthLarge = 280;
export const isEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const unauthorizedText =
  "Sorry, you don't have authorization to access this page.";

export const defaultUserPermissions = {
  // User page
  u1: false,
  u2: false,
  u3: false,
  // Location page
  l1: false,
  l2: false,
  l3: false,
  // Incidents page
  canAddNewForms: false,
  canAccessIncidentFormsPage: false,
  canSubmitForms: false,
  canViewSubmittedReports: false,
  // Company page
  canAccessCompanyProfilePage: false,
  canEditCompanyData: false,
  // Positions page
  p1: false,
  p2: false,
  canImpersonate: false,
  canViewAuditPage: false,
  // Report Type Pages
  r1: false,
  r2: false,
  r3: false,
  r4: false,
  // grouping
  gL1: false,
  gL2: false,
  gL3: false,
  userLocationUUIDs: [],
  userUUID: null,
};

export const superUserPermissions = {
  // User page
  u1: true,
  u2: true,
  u3: true,
  canImpersonate: true,

  // Location page
  l1: true,
  l2: true,
  l3: true,
  // Incidents page
  canAddNewForms: true,
  canAccessIncidentFormsPage: true,
  canSubmitForms: true,
  canViewSubmittedReports: true,
  // Company page
  canAccessCompanyProfilePage: true,
  canEditCompanyData: true,
  // Positions page
  p1: true,
  p2: true,
  canViewAuditPage: true,
  // Report Type Pages
  r1: true,
  r2: true,
  r3: true,
  r4: true,
  // grouping
  gL1: true,
  gL2: true,
  gL3: true,
  // groups
  g1: true,
  g2: true,
  g3: true,
  // assets
  a1: true,
  a2: true,
  a3: true,
  //vendors
  v1: true,
  v2: true,
};

export const localStorageKeys = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  permissions: "permissions",
  user: "user",
  impersonationCompany: "impersonationCompany",
};

export const accessTypes = [
  { key: 1, value: "Public", desc: "Anyone with a link can submit a report" },
  { key: 2, value: "Internal", desc: "Only company users can submit a report" },
  {
    key: 3,
    value: "Location Based",
    desc: "Only users assigned to specified locations can submit a report",
  },
  {
    key: 4,
    value: "Task Based",
    desc: "Only users with a task to submit can submit a report",
  },
];

export const includeSideMenu = [
  urlRoutes.dashboard,
  urlRoutes.accounts,
  urlRoutes.companyProfile,
  urlRoutes.companyUsers,
  urlRoutes.companyPositions,
  urlRoutes.companyLocations,
  urlRoutes.forms,
  urlRoutes.incidentReports,
  urlRoutes.auditReports,
  urlRoutes.itTicketing,
  urlRoutes.maintenanceRequests,
  urlRoutes.surveys,
  urlRoutes.otherReports,
  urlRoutes.formConfiguration,
  urlRoutes.form,
  urlRoutes.reportView,
  urlRoutes.reportViewDeprecated,
  urlRoutes.glAccounts,
  urlRoutes.assets,
  urlRoutes.preventativeMaintenance,
  urlRoutes.disposedAssets,
  urlRoutes.assetParts,
  urlRoutes.assetSuppliers,
  urlRoutes.vendors,
  urlRoutes.vendorContacts,
  urlRoutes.tasks,
  urlRoutes.notifications,
];

export const adminPages = [
  urlRoutes.companyProfile,
  urlRoutes.companyUsers,
  urlRoutes.companyPositions,
  urlRoutes.companyLocations,
  urlRoutes.glAccounts,
];

export const assetsPages = [
  urlRoutes.assets,
  urlRoutes.preventativeMaintenance,
  urlRoutes.disposedAssets,
  urlRoutes.assetParts,
  urlRoutes.assetSuppliers,
];

export const reportingPages = [
  urlRoutes.forms,
  urlRoutes.incidentReports,
  urlRoutes.auditReports,
  urlRoutes.itTicketing,
  urlRoutes.maintenanceRequests,
  urlRoutes.surveys,
  urlRoutes.otherReports,
  urlRoutes.formConfiguration,
  urlRoutes.form,
  urlRoutes.reportView,
  urlRoutes.reportViewDeprecated,
];

export const vendorPages = [urlRoutes.vendors, urlRoutes.vendorContacts];

export const comingSoonPages = [];

export const questionTypeCodes = {
  dropdown: 1,
  textBox: 2,
  multipleChoice: 3,
  calendar: 4,
  paragraph: 5,
  upload: 6,
  datalist: 7,
  formSend: 8,
  rank: 9,
  time: 10,
  datetime: 11,
  radio: 12,
  rate: 13,
  datalistMultiple: 14,
  number: 15,
  numberRange: 16,
  questionGroup: 17,
  epic: 18,
  assetField: 19,
};

export const datalistQuestionTypes = [
  questionTypeCodes.datalist,
  questionTypeCodes.datalistMultiple,
];

export const fullSpanQuestions = [
  questionTypeCodes.questionGroup,
  questionTypeCodes.paragraph,
];

export const requiresPhaseTwo = [
  questionTypeCodes.dropdown,
  questionTypeCodes.multipleChoice,
  questionTypeCodes.datalist,
  questionTypeCodes.datalistMultiple,
  questionTypeCodes.radio,
  // questionTypeCodes.questionGroup,
];

export const hasSubQuestions = [
  questionTypeCodes.dropdown,
  questionTypeCodes.multipleChoice,
  questionTypeCodes.datalist,
  questionTypeCodes.datalistMultiple,
  questionTypeCodes.radio,
  questionTypeCodes.questionGroup,
];

export const questionTypes = [
  {
    groupName: "Lists",
  },
  {
    key: questionTypeCodes.dropdown,
    value: "Dropdown Menu",
  },
  {
    key: questionTypeCodes.multipleChoice,
    value: "Multiple Select",
  },
  {
    key: questionTypeCodes.radio,
    value: "Radio Buttons",
  },
  {
    key: questionTypeCodes.datalist,
    value: "Data List - Dropdown",
  },
  {
    key: questionTypeCodes.datalistMultiple,
    value: "Data List - Multiple",
  },
  {
    key: questionTypeCodes.epic,
    value: "Patient Information - Epic",
  },
  {
    groupName: "Input",
  },
  {
    key: questionTypeCodes.textBox,
    value: "Text Input",
  },
  {
    key: questionTypeCodes.paragraph,
    value: "Paragraph",
  },
  {
    key: questionTypeCodes.number,
    value: "Number",
  },
  // {
  //   key: questionTypeCodes.numberRange,
  //   value: "Number Range",
  // },
  {
    groupName: "Date/Time",
  },
  {
    key: questionTypeCodes.calendar,
    value: "Calendar",
  },
  {
    key: questionTypeCodes.time,
    value: "Time",
  },
  {
    key: questionTypeCodes.datetime,
    value: "Date & Time",
  },
  {
    groupName: "Other",
  },
  {
    key: questionTypeCodes.assetField,
    value: "Asset Field",
  },
  {
    key: questionTypeCodes.questionGroup,
    value: "Question Group",
  },
  {
    key: questionTypeCodes.upload,
    value: "File Upload",
  },
  // {
  //   key: questionTypeCodes.formSend,
  //   value: "Form Sender",
  // },
  {
    key: questionTypeCodes.rate,
    value: "Rate",
  },
  // {
  //   key: 9,
  //   value: "Rank",
  // },
];

export const dataListTypes = (groups) => {
  return [
    {
      groupName: "User Lists",
    },
    {
      key: 1,
      value: "All Users",
    },
    ...groups
      ?.filter((group) => group.type === 1)
      .map((group) => ({
        key: group.uuid,
        value: group.name,
      })),
    {
      groupName: "Location Lists",
    },
    {
      key: 2,
      value: "All Locations",
    },
    ...groups
      ?.filter((group) => group.type === 2)
      .map((group) => ({
        key: group.uuid,
        value: group.name,
      })),
    {
      groupName: "GL Account Lists",
    },
    {
      key: 3,
      value: "All GL Accounts",
    },
    ...groups
      ?.filter((group) => group.type === 3)
      .map((group) => ({
        key: group.uuid,
        value: group.name,
      })),
  ];
};

export const defaultTaskValues = {
  assignment: "",
  userUUID: "",
  groupUUID: "",
  questionUUID: "",
  positionUUID: "",
  startTime: "",
  completionTime: "",
  title: "",
  type: undefined,
  formStatusChangeId: "",
  taskFormUUID: "",
  description: "",
};

export const defaultTaskErrors = {
  assignment: false,
  userUUID: false,
  questionUUID: false,
  positionUUID: false,
  startTime: false,
  completionTime: false,
  title: false,
  type: false,
  formStatusChangeId: false,
  taskFormUUID: false,
  description: false,
};

export const taskTypes = [
  { key: 1, value: "Submit Another Form" },
  { key: 2, value: "Comment/File Upload" },
  { key: 3, value: "Approval Event" },
];

export const approvalTaskType = 3;

export const approvalDecisions = {
  approved: "Approved",
  rejected: "Rejected",
};

export const taskAssignmentOptions = [
  {
    text: "Specific user or group",
    id: 1,
  },
  {
    text: "Based on answer to question",
    id: 2,
  },
  {
    text: "Person who submits the form",
    id: 3,
  },
  {
    text: "Manually assign after submission",
    id: 4,
  },
  {
    text: "Position at the asset's location",
    id: 5,
  },
];

export const startOptions = [
  {
    text: "Anytime after submission",
    id: 2,
  },
  {
    text: "After previous task(s) completion",
    id: 1,
  },
];

export const dueOptions = [
  {
    text: "1 Day",
    id: 1,
  },
  {
    text: "2 Days",
    id: 2,
  },
  {
    text: "3 Days",
    id: 3,
  },
  {
    text: "4 Days",
    id: 4,
  },
  {
    text: "5 Days",
    id: 5,
  },
  {
    text: "6 Days",
    id: 6,
  },
  {
    text: "7 Days",
    id: 7,
  },
];

export const hasSelectAnswer = [
  questionTypeCodes.multipleChoice,
  questionTypeCodes.dropdown,
  questionTypeCodes.datalist,
  questionTypeCodes.datalistMultiple,
  questionTypeCodes.radio,
];

export const hasTextAnswer = [
  questionTypeCodes.textBox,
  questionTypeCodes.paragraph,
];

export const noAnswerProvidedText = "No Answer Provided";

export const responseCodes = {
  OK: 200,
  Created: 201,
};

export const newUserObject = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  positionUUID: "",
  userLocations: [],
  userGroups: [],
  userPermission: {
    ...defaultUserPermissions,
    id: null,
    position: null,
    positionUUID: null,
  },
};

export const signUpNewUserObject = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  positionUUID: "",
  userLocations: [],
  password: "",
  confirmPassword: "",
};

export const userErrorsObject = {
  firstName: false,
  lastName: false,
  email: false,
  phone: false,
};

export const formatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const numberFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 10,
});

export const moneyFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const taskRepeatFrequencyOptions = [
  {
    key: 1,
    value: "Daily",
  },
  {
    key: 2,
    value: "Weekly",
  },
  {
    key: 3,
    value: "Bi Weekly",
  },
  {
    key: 4,
    value: "Monthly",
  },
  {
    key: 5,
    value: "Quarterly",
  },
  {
    key: 6,
    value: "Annually",
  },
];

export const formTypes = {
  incidentReport: 1,
  auditReport: 2,
  itTicketing: 3,
  maintenanceRequests: 4,
  surveys: 5,
  other: 6,
  pm: 7,
  workOrders: 8,
  performance: 9,
  assetOther: 10,
};

export const assetFormTypeCodes = [
  formTypes.pm,
  formTypes.workOrders,
  formTypes.performance,
  formTypes.assetOther,
];

export const formTypesNames = {
  1: "Incident Report",
  2: "Audit Report",
  3: "Support Tickets",
  4: "Maintenance Requests",
  5: "Surveys",
  6: "Other",
  7: "Preventative Maintenance",
  8: "Work Orders",
  9: "Performance",
  10: "Asset Other",
};

export const groupTypes = {
  user: 1,
  location: 2,
  glAccount: 3,
  asset: 4,
};

export const groupTypeNames = {
  1: "user",
  2: "location",
  3: "glAccount",
  4: "asset",
};

export const fieldTypeCodes = {
  text: 1,
  number: 2,
  currency: 3,
  pictures: 4,
  documents: 5,
  date: 6,
  dropdown: 7,
};

export const fieldTypes = [
  {
    name: "Text",
    icon: <AssetFieldIcon type={1} />,
    desc: "Make, Model, Serial No, etc.",
    type: fieldTypeCodes.text,
  },
  {
    name: "Number",
    icon: <AssetFieldIcon type={2} />,
    desc: "Mileage, Mrs Ran, etc.",
    type: fieldTypeCodes.number,
  },
  {
    name: "Currency",
    icon: <AssetFieldIcon type={3} />,
    desc: "Initial Cost, etc.",
    type: fieldTypeCodes.currency,
  },
  {
    name: "Pictures",
    icon: <AssetFieldIcon type={4} />,
    desc: "Equip Pictures, Trouble Shooting Charts etc.",
    type: fieldTypeCodes.pictures,
  },
  {
    name: "Documents",
    icon: <AssetFieldIcon type={5} />,
    desc: "PDFs, Manuals, Contracts, etc.",
    type: fieldTypeCodes.documents,
  },
  {
    name: "Date",
    icon: <AssetFieldIcon type={6} />,
    desc: "Warranty Date, Install Date, etc.",
    type: fieldTypeCodes.date,
  },
];

export const dispositionOptions = [
  { value: 1, label: "Sold" },
  { value: 2, label: "Scrapped / Trashed" },
  { value: 3, label: "Donated" },
  { value: 4, label: "Returned to Supplier" },
  { value: 5, label: "Lost" },
  { value: 6, label: "Stolen" },
  { value: 7, label: "Retired / Decommissioned" },
  { value: 8, label: "Duplicate Entry" },
  { value: 9, label: "Other" },
];
